import { render, staticRenderFns } from "./wangEdit.vue?vue&type=template&id=0b5d8e53&scoped=true"
import script from "./wangEdit.vue?vue&type=script&lang=js"
export * from "./wangEdit.vue?vue&type=script&lang=js"
import style0 from "./wangEdit.vue?vue&type=style&index=0&id=0b5d8e53&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5d8e53",
  null
  
)

export default component.exports